/**
* Created by kongwm.kong on 2017/7/25.
*/
<template>
    <div class="layout_n">
        <div class="net_management_wrap">
            <div class="search_wrap clearfix">
                <div class="add_product">
                    <router-link to="/manager/0/0">
                        <button class="btn btn-bg-def">新增基金经理<span>+</span></button>
                    </router-link>

                </div>
                <div class="search right" v-show="isJoined==1">
                    <input type="text" v-model="managerName" placeholder="请输入经理姓名">
                    <button class="sear_btn" @click="goSearch"></button>
                </div>
            </div>
            <div class="submenu_wrap">
                <div :class="{'menu-item':true,'active':item1}" @click="joined">已加入基金经理</div>
                <div :class="{'menu-item':true, 'active':item2}" @click="joining">待加入基金经理</div>
            </div>
            <manager-table :isJoined="isJoined" :noParams="noParams" :managerName="managerName" :isSearch="isSearch" ></manager-table>
        </div>
    </div>

</template>
<script>
    import managerTable from './manager_table';
    export default {
        data(){
            return{
                item1: true,
                item2: false,
                noParams: true,
                managerName: '',
                isSearch: 1,
            }
        },
        components:{
            managerTable
        },
        computed: {
            isJoined(){
                this.noParams = true;
                if(this.item1){
                    return 1;
                }else {
                    return 2;
                }

            }
        },
        created(){
//            this.$store.commit('getLoginInfo', this.getItem);
            this.getItem();
        },
        methods: {
            getItem(){
                let item = this.$route.query.item;
                if(item==2){
                    this.joining();
                }
            },
            joined(e){
                this.item2 = false;
                this.item1 = true;
            },
            joining(e){
                this.item1 = false;
                this.item2 = true;
            },
            goSearch(){
                this.isSearch =  this.isSearch == 1 ? 2: 1;
                this.noParams = false;
            }
        }
    }
</script>
<style lang="scss" type="text/scss" scoped>
    @import "../../assets/css/common/center";
    .layout_n{
        @include mainMar;
        .net_management_wrap{
            padding: 50px 38px 230px;
            @include bgff;
            .search_wrap{
                .add_product{
                    width:168px;
                    float: left;
                    .btn{
                        color:#fff;
                        background: $btn_408;
                        height:46px;
                        width:168px;
                        font-size: 18px;
                        letter-spacing: -0.43px;
                        line-height: 46px;
                        &:active, &:hover{
                            span{
                                color:$btn_ffa;
                            }
                        }
                        span{
                            display: inline-block;
                            width:20px;
                            height:20px;
                            border-radius: 50%;
                            background: #fff;
                            color:$btn_408;
                            font-weight: bold;
                            vertical-align: middle;
                            line-height: 1;
                            text-indent: -1px;
                            margin-left:5px;
                        }
                    }
                }
                .search{
                    margin-top:4px;
                    input{
                        border: 1px solid $border_bfb;
                        height:40px;
                        width:309px;
                        padding:10px 0;
                        text-indent: 20px;
                        line-height: 16px;
                        font-size:16px;
                        vertical-align: middle;
                    }
                    .sear_btn{
                        width:40px;
                        height:40px;
                        background: url(../../assets/img/common/search.png) center center no-repeat;
                        background-color: $btn_408;
                        vertical-align: middle;
                        margin-left: -4px;
                    }
                }
            }
            .submenu_wrap{
                margin-top:50px;
                @include subMenu;
                margin-bottom:50px;
            }

        }
    }
</style>


// WEBPACK FOOTER //
// src/views/manager/index.vue